import { DI } from '@microsoft/fast-foundation';
/**
 * Configuration options for the Connect (WS) instance.
 * @internal
 */
export const ConnectConfig = DI.createInterface();
/**
 * Configuration options for the Connect (HTTP) instance.
 * @internal
 */
export const HttpConnectConfig = DI.createInterface();
